module.exports = __webpack_public_path__ + "static/media/mask16.0574d514.JPG";